import {
  Button as MUIButton,
  type ButtonProps as MUIButtonProps,
} from '@mui/material';
import { EventType } from '@/lib/types';

export { type MUIButtonProps as ButtonProps };

export interface TrackedButtonProps extends MUIButtonProps {
  trackClick?: (event: {
    name: string;
    properties: { eventType: EventType; buttonLabel: string };
  }) => void;
  trackEventName?: string;
  eventType?: EventType;
}

export function Button({
  trackClick,
  trackEventName,
  eventType = EventType.BUTTON_CLICK,
  onClick,
  ...props
}: TrackedButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (trackClick && trackEventName) {
      trackClick({
        name: trackEventName,
        properties: {
          eventType,
          buttonLabel: props.children?.toString() || 'Unknown Button',
        },
      });
    }
    if (onClick) {
      onClick(event);
    }
  };

  return <MUIButton {...props} onClick={handleClick} />;
}
